import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-profile-avatar';
import { StarRatingSummaryComponent } from '@rma/public/reviews/public/ui-rating';
import { MarketReportWithQrCode } from '../domain/market-report';
import { MarketReportTopAwardComponent } from '../ui-market-report-top-award/market-report-top-award.component';

@Component({
  selector: 'rma-market-report-print-header',
  templateUrl: './market-report-print-header.component.html',
  styleUrls: ['./market-report-print-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProfileAvatarComponent, StarRatingSummaryComponent, MarketReportTopAwardComponent, RmaIconComponent, TranslocoPipe],
})
export class MarketReportPrintHeaderComponent implements OnInit {
  @Input() public report!: MarketReportWithQrCode;

  public messageParagraphs?: string[] | null;

  ngOnInit() {
    const message = this.report.customMessage?.trim()?.length ? this.report.customMessage : this.report.profile.bio;
    this.messageParagraphs = message?.match(/[^\r\n]+/g);
  }
}
